import styles from './Loader.module.css';
interface LoaderProps {
    text: string;
}
const Loader: React.FC<LoaderProps> = ({ text }) => (
    <div className={styles.loaderContainer}>
        <div className={styles.loader}>
            <div className={styles.dot} />
            <div className={styles.dot} />
            <div className={styles.dot} />
        </div>
        <p className={styles.text}>{String(text ?? '')}</p>
    </div>
);

export default Loader;
